import { render, staticRenderFns } from "./OnlyStudentListRequest.vue?vue&type=template&id=4a4f469c&scoped=true&"
import script from "./OnlyStudentListRequest.vue?vue&type=script&lang=js&"
export * from "./OnlyStudentListRequest.vue?vue&type=script&lang=js&"
import style0 from "./OnlyStudentListRequest.vue?vue&type=style&index=0&id=4a4f469c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4f469c",
  null
  
)

export default component.exports